module.exports = __webpack_public_path__ + "static/media/google-icon.1e8ce301.png";